<template>
  <div class="form-item">
    <b-form-group :label-for="formLabel">
      <label class="mcc-form-label" :class="{ required: required }"
        >{{ formLabel }}:</label
      >
      &nbsp;&nbsp;<slot name="labelSmall" />
      <div class="form-item-block mb-3">
        <div class="form-item-input">
          <b-row v-show="isEdit">
            <b-col md="8">
              <slot />
            </b-col>
            <div class="form-item-btn">
              <b-button
                variant="primary"
                class="btn-icon"
                @click="saveFormItem"
              >
                <feather-icon icon="ArchiveIcon" />
              </b-button>
              <b-button
                style="margin-left: 10px;overflow: visable"
                variant="outline-primary"
                class="btn-icon"
                @click.stop="cancelEdit"
              >
                <feather-icon icon="RotateCcwIcon" />
              </b-button>
            </div>
          </b-row>
          <div v-if="!isEdit" class="form-item-value">
            <span style="display: inline-block;">{{ formValue }}</span>
          </div>
          <my-tooltip :tooltip="$t(`_components.btns.edit`)">
            <feather-icon
              v-if="!isEdit && !onlyShow"
              class="form-item-icon"
              icon="Edit2Icon"
              size="18"
              :color="editColor"
              @click="changeEdit"
              @mouseenter="changeEditColor"
              @mouseleave="changeLeaveEditColor"
            />
          </my-tooltip>
        </div>
      </div>
    </b-form-group>
  </div>
</template>

<script>
import { BFormGroup, BRow, BCol, BButton } from 'bootstrap-vue'
import MyTooltip from '@/components/myTooltip.vue'

export default {
  components: {
    BFormGroup,
    BRow,
    BCol,
    BButton,
    MyTooltip,
  },
  /**
   * type 默认为 input ,为select 时为选框，要传入 dictOptions
   * formLabel 标题
   * formValue 值
   * onlyShow 用于表示当前字段是否是只读
   */
  props: {
    formLabel: {
      type: String,
      default: '',
    },
    formField: {
      type: String,
      default: '',
    },
    formValue: {
      type: [String, Number, Boolean],
      default: '',
    },
    onlyShow: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isEdit: false,
      formLoading: false,
      editColor: '#BABFC7',
    }
  },
  watch: {
    formValue(e) {
      this.$emit('input', e)
    },
  },
  methods: {
    changeValue(e) {
      this.$emit('input', e)
    },
    changeEdit() {
      if (!this.onlyShow) {
        this.isEdit = true
      }
      console.log(this.isEdit, this.formField)
      this.$emit('changeEdit')
    },
    cancelEdit() {
      this.resetEditBtn()
      this.$emit('clearFormItem')
    },
    changeEditColor() {
      this.editColor = '#13419D'
    },
    resetEditBtn() {
      this.isEdit = false
      this.editColor = '#BABFC7'
    },
    changeLeaveEditColor() {
      this.resetEditBtn()
    },
    saveFormItem() {
      this.formLoading = true
      const done = () => {
        if (this.isEdit) {
          this.formLoading = false
          this.resetEditBtn()
        }
      }
      this.$emit('saveFormItem', done)
    },
    hasRequired(option = {}) {
      const rules = option.rules || ''
      return rules.indexOf('required') !== -1
    },
  },
}
</script>

<style lang="scss" scoped="">
@import '@/assets/scss/form/index.scss';
.form-item {
  height: 100%;
  .form-group {
    margin-left: 15px;
    padding-top: 5px;
    height: 60px;
  }
  &-block {
    width: 100%;
    .form-item-input {
      width: 100%;
    }
  }
  &-value {
    height: 37px;
    display: inline-block;
  }
  &:hover {
    background-color: rgba($color: #babfc7, $alpha: 0.1);
  }
  &-input {
    display: inline-block;
    &-left {
      width: calc(100%-60px);
    }
    &-btn {
      width: 60px;
    }
  }
  &-icon {
    margin-left: 10px;
    cursor: pointer;
    display: inline-block;
  }
}
</style>
